import * as actionTypes from './actionTypes';

export function fetchBrokerageOfferData(token) {
  return {
    payload: { token },
    type: actionTypes.FETCH_BROKERAGE_OFFER_DATA,
  };
}

export function beginOfferAccept() {
  return {
    type: actionTypes.BEGIN_OFFER_ACCEPT,
  };
}

export function maybeAcceptInvitation() {
  return {
    type: actionTypes.MAYBE_ACCEPT_INVITATION,
  };
}

export function acceptInvitation() {
  return {
    type: actionTypes.ACCEPT_INVITATION,
  };
}

export function beginLoadingBrokerageOfferData() {
  return {
    type: actionTypes.BEGIN_LOADING_BROKERAGE_OFFER_DATA,
  };
}

export function receiveBrokerageOfferData(brokerageOfferData) {
  return {
    payload: { brokerageOfferData },
    type: actionTypes.RECEIVE_BROKERAGE_OFFER_DATA,
  };
}

export function fetchOtherBids(token) {
  return {
    payload: { token },
    type: actionTypes.FETCH_OTHER_BIDS,
  };
}

export function receiveOtherBidsData(otherBidsData) {
  return {
    payload: { otherBidsData },
    type: actionTypes.RECEIVE_OTHER_BIDS_DATA,
  };
}

export function updateBrokerageOfferDetails(payload) {
  return {
    payload,
    type: actionTypes.UPDATE_BROKERAGE_OFFER_DETAILS,
  };
}

export function updatePurchaseAgreement(payload) {
  return {
    payload,
    type: actionTypes.UPDATE_PURCHASE_AGREEMENT,
  };
}

export function receiveInvitationData(invitationData) {
  return {
    payload: { invitationData },
    type: actionTypes.RECEIVE_INVITATION_DATA,
  };
}

export function setInvitationToken(invitationToken, brokerageOfferToken) {
  return {
    payload: { invitationToken, brokerageOfferToken },
    type: actionTypes.SET_INVITATION_TOKEN,
  };
}

export function storeInvitationTokenFromLocalStorage(brokerageOfferToken) {
  return {
    payload: { token: brokerageOfferToken },
    type: actionTypes.STORE_INVITATION_TOKEN_FROM_LOCAL_STORAGE,
  };
}

export function hideDeclineOfferModal() {
  return {
    type: actionTypes.HIDE_DECLINE_OFFER_MODAL,
  };
}

export function showDeclineOfferModal() {
  return {
    type: actionTypes.SHOW_DECLINE_OFFER_MODAL,
  };
}

export function createNewUserAccount(email: string, password: string) {
  return {
    payload: { email, password },
    type: actionTypes.CREATE_NEW_USER_ACCOUNT,
  };
}

export function handleReturningUser(email: string, password: string) {
  return {
    payload: { email, password },
    type: actionTypes.HANDLE_RETURNING_USER,
  };
}

export function onDeclineSubmit(declineReasons: Set<string>, feedbackText: string) {
  return {
    payload: { declineReasons, feedbackText },
    type: actionTypes.ON_DECLINE_SUBMIT,
  };
}

export function redirectToError(error) {
  return {
    payload: { error },
    type: actionTypes.REDIRECT_TO_ERROR,
  };
}

export function setNewOfferRequested() {
  return {
    type: actionTypes.SET_NEW_OFFER_REQUESTED,
  };
}

export function requestNewOffer() {
  return {
    type: actionTypes.REQUEST_NEW_OFFER,
  };
}

export function loginError(errorMsg: string) {
  return {
    payload: { errorMsg },
    type: actionTypes.LOGIN_ERROR,
  };
}

export function onSubmitPurchaseAgreement() {
  return {
    type: actionTypes.SUBMIT_PURCHASE_AGREEMENT,
  };
}

export function redirectToComplete() {
  return {
    type: actionTypes.REDIRECT_TO_COMPLETE,
  };
}
